import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAdminAuth } from "../contexts/AdminAuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function AdminLogin() {
    const { admin, login } = useAdminAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    if (admin) return <Navigate to="/admin" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setBusy(true);
        try {
            await login(email.trim().toLowerCase(), password);
            navigate("/admin");
        } catch (e2) {
            setErr(formatApiErrorDetail(e2.response?.data?.detail) || "Login failed");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen bg-ivory grid grid-cols-1 lg:grid-cols-2" data-testid="admin-login-page">
            <div className="hidden lg:block bg-beige relative overflow-hidden">
                <div className="absolute inset-0 flex flex-col justify-end p-16">
                    <span className="label-eyebrow">Atelier Console</span>
                    <h1 className="mt-3 font-display text-5xl text-inkDark leading-tight">Sukaanyas<br />Admin Panel</h1>
                    <p className="mt-4 text-inkMuted max-w-sm">Curate the boutique &mdash; products, collections, settings and feature toggles.</p>
                </div>
                <img
                    src="https://images.unsplash.com/photo-1610030181087-540017dc9d77?w=1200&q=80"
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover opacity-40"
                />
            </div>
            <div className="flex items-center justify-center p-6 lg:p-16">
                <form onSubmit={submit} className="w-full max-w-md" data-testid="admin-login-form">
                    <div className="font-display text-3xl text-inkDark">Welcome back</div>
                    <p className="mt-1 text-inkMuted">Sign in to manage Sukaanyas.</p>

                    <div className="mt-8">
                        <label className="label-eyebrow">Email</label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="mt-2 w-full rounded-xl border border-inkDark/10 bg-white px-4 py-3 outline-none focus:border-skyblueDeep"
                            placeholder="Email"
                            data-testid="admin-email-input"
                        />
                    </div>
                    <div className="mt-5">
                        <label className="label-eyebrow">Password</label>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="mt-2 w-full rounded-xl border border-inkDark/10 bg-white px-4 py-3 outline-none focus:border-skyblueDeep"
                            placeholder="Password"
                            data-testid="admin-password-input"
                        />
                    </div>

                    {err ? (
                        <div className="mt-4 rounded-xl bg-red-50 text-red-600 px-4 py-3 text-sm" data-testid="admin-login-error">{err}</div>
                    ) : null}

                    <button
                        type="submit"
                        disabled={busy}
                        className="btn-pill mt-8 w-full justify-center disabled:opacity-50"
                        data-testid="admin-login-submit"
                    >
                        {busy ? "Signing in…" : "Sign in"}
                    </button>
                </form>
            </div>
        </div>
    );
}
